import { MediaCardItem } from 'strapi/component/shared/types';
import { ReactComponentType } from 'strapi/component/types';
import { PageType, PageTypes } from 'strapi/page/types';
import { ReactComponentBuildResponse } from 'strapi/types';

import { collectImageComponentParams } from '../shared/collector';

import { Carousel } from './Carousel';

export const collectCarouselParams = (
  _: PageType,
  page: PageTypes
): ReactComponentBuildResponse<typeof Carousel> | undefined => {
  if (!('carousel' in page) || !page.carousel) {
    return undefined;
  }

  let items: MediaCardItem[] = [];

  if (
    page.carousel.create_use_case_pages &&
    page.carousel.create_use_case_pages.length > 0
  ) {
    items =
      page.carousel.create_use_case_pages?.map((x) => ({
        title: x.use_case?.name ?? '',
        image: collectImageComponentParams(x.cover)!,
        url: x.path,
      })) ?? [];
  }

  if (
    page.carousel.templates_use_case_pages &&
    page.carousel.templates_use_case_pages.length > 0
  ) {
    items = items.concat(
      page.carousel.templates_use_case_pages?.map((x) => ({
        title: x.use_case?.name ?? '',
        image: {
          filename: '',
          width: 0,
          height: 0,
          url: x.cover!,
        },
        url: x.path,
      })) ?? []
    );
  }

  if (
    page.carousel.templates_sub_use_case_pages &&
    page.carousel.templates_sub_use_case_pages.length > 0
  ) {
    items = items.concat(
      page.carousel.templates_sub_use_case_pages?.map((x) => ({
        title: x.sub_use_case?.name ?? '',
        image: {
          filename: '',
          width: 0,
          height: 0,
          url: x.cover!,
        },
        url: x.path,
      })) ?? []
    );
  }

  if (items?.length === 0) {
    return undefined;
  }

  return {
    component: ReactComponentType.Carousel,
    props: {
      title: page.carousel.title,
      description: page.carousel.description,
      items: items ?? [],
      backgroundColor: page.carousel.backgroundColor,
    },
  };
};
